__turbopack_context__.v({
  "lightBlueKeyPoints": "NewArticleLayoutMain-module-scss-module__UFHLtq__lightBlueKeyPoints",
  "wrapper": "NewArticleLayoutMain-module-scss-module__UFHLtq__wrapper",
});
